module.exports = __webpack_public_path__ + "static/stage-2abf600a4d025a4aa7434e518e0cc3c9.png";